import { Grid, Typography } from '@mui/material';
import React from 'react';
import ploygonlogo from '../../Asset/crossplateform/polygon-logo-colored.png';
import avalanchelogo from '../../Asset/crossplateform/Avalanche_Horizontal_Red.svg';
import binancelogo from '../../Asset/crossplateform/binance.png';
import solanalogo from '../../Asset/crossplateform/solana_logo.png';
import ethereumlog from '../../Asset/crossplateform/ethereum-logo.png';
import okxlogo from '../../Asset/crossplateform/OKX-logo.png';
import { CROSSCHAINPLATFORM } from '../../Constant/constant';
const CrossChainPlateForm = () => {
  return (
      <Grid container className='cross-chain-container'>
      <Grid item xl={12} sm={12} xs={12} md={12} lg={12} className="cross-chain-text-backward">
          <Typography variant='h1' className='cross-chain-text-backward-text'>#1</Typography>
        </Grid>
        <Grid item xl={12} sm={12} xs={12} md={12} lg={12} className="cross-chain-text-front-text">
          <Typography variant='h4' className='cross-chain-text-font'>{CROSSCHAINPLATFORM}</Typography>
        </Grid>
        <Grid item xl={12} sm={12} xs={12} md={12} lg={12} className="cross-chain-image">
          <Grid container sx={{display:'flex',flexWrap:'wrap',alignItems:'center'}}>
          <Grid item xl={4} sm={12} xs={12} md={4} lg={4}>
          <img src={ploygonlogo} className="image-hover" alt=" " height={'200px'} />
        </Grid>
        <Grid item xl={4} sm={12} xs={12} md={4} lg={4}>
        <img src={binancelogo} className="image-hover" alt=" " height={'250px'}/>
        </Grid>
        <Grid item xl={4} sm={12} xs={12} md={4} lg={4} s>
        <img src={solanalogo} className="image-hover" alt=" " height={'130px'}/>
        </Grid>
        <Grid item xl={4} sm={12} xs={12} md={4} lg={4} >
        <img src={avalanchelogo} className="image-hover" alt=" " height={'50px'}/>
        </Grid>
        <Grid item xl={4} sm={12} xs={12} md={4} lg={4} sx={{padding:'25px'}}>
        <img src={ethereumlog} className="image-hover" alt=" " height={'120px'}/>
        </Grid>
        <Grid item xl={4} sm={12} xs={12} md={4} lg={4}>
        <img src={okxlogo} className="image-hover" alt="" height={'50px'}/>
        </Grid>
          </Grid>
        </Grid>
      </Grid>
  );
};

export default CrossChainPlateForm;